import { Link } from 'react-router-dom';
import { NAV, SITE, OUTLETS } from '../data/site';
import Stamp from './Stamp';

export default function SiteFooter() {
  return (
    <footer className="bg-[#1F140E] grain text-[#E8DCC9] mt-0" data-testid="site-footer">
      <div className="relative mx-auto max-w-6xl px-5 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5 relative z-10">
          <div className="flex items-start gap-5">
            <Stamp size={110} dark />
            <div>
              <p className="font-display text-2xl font-bold text-[#FDFBF7]">Ayam Goreng Widuran</p>
              <p className="font-pricemono text-[11px] tracking-widest uppercase text-[#D9822B] mt-1">
                Solo · Sejak {SITE.since}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-[#CBBBA6]">
                Rumah makan keluarga khas Solo — ayam kampung goreng dengan kremesan gurih yang
                renyah, dijaga lintas generasi.
              </p>
            </div>
          </div>
          <p className="mt-6 text-xs leading-relaxed text-[#B09E88] border border-[#4a3526] rounded-md p-3">
            Seluruh produk kami non-halal. Label ini kami cantumkan terbuka di outlet dan kemasan
            demi kenyamanan pelanggan.
          </p>
        </div>
        <nav className="md:col-span-3 relative z-10" aria-label="Navigasi footer">
          <h2 className="font-pricemono text-[11px] tracking-widest uppercase text-[#D9822B]">Jelajahi</h2>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-${n.testid}`}
                  className="text-sm text-[#E8DCC9] hover:text-[#E5A83B] transition-colors"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="md:col-span-4 relative z-10">
          <h2 className="font-pricemono text-[11px] tracking-widest uppercase text-[#D9822B]">Outlet Kami</h2>
          <ul className="mt-4 space-y-3 text-sm text-[#CBBBA6]">
            {OUTLETS.map((o) => (
              <li key={o.id}>
                <span className="text-[#FDFBF7] font-medium">{o.name}:</span> {o.address}
              </li>
            ))}
          </ul>
          <div className="mt-5 flex flex-wrap gap-3">
            <a
              data-testid="footer-instagram-solo"
              href={SITE.instagram.solo}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-semibold text-[#E5A83B] hover:text-[#FDFBF7] transition-colors"
            >
              @ayamgorengwiduransolo
            </a>
            <a
              data-testid="footer-instagram-bali"
              href={SITE.instagram.bali}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-semibold text-[#E5A83B] hover:text-[#FDFBF7] transition-colors"
            >
              @ayamwiduranbali
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#3a281c] relative z-10">
        <div className="mx-auto max-w-6xl px-5 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#B09E88]">
          <p>© {SITE.since}–2026 Ayam Goreng Widuran, Surakarta.</p>
          <p>
            <a href={SITE.domain + '/'} className="hover:text-[#E5A83B] transition-colors">
              ayamgorengwiduran.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
